import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionService } from '../../../shared/session-service/session.service';
import { DialogService, ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../../shared/constants/apiurl-constants';
import { EmployeesInSurvey, GenerateSurvey } from '../../../shared/models/generate-survey.model';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { SurveyPrepDataEntity, EngagementGroupProject, EngagementGroupActivity, TimeSurveyGroupRequestDto } from 'src/app/shared/models/Survey-Creation/SurveyCreation.model';
import { copyObject } from 'src/app/shared/lib/custom-tools';
@Injectable({
  providedIn: 'root',
})
export class AssignActivitiesProjectsService {
  activitiesProjectTableRefresh = new BehaviorSubject({});
  activityProjectData = new BehaviorSubject<boolean>(false);
  assignActivitiesProjects = new BehaviorSubject({});
  refreshList = this.activitiesProjectTableRefresh.asObservable();
  showAssignLink = this.assignActivitiesProjects.asObservable();
  engagementId: string = this.sessionService.getSession('engagementId');
  generateSurvey: GenerateSurvey;

  constructor(
    public sessionService: SessionService,
    public dialogService: DialogService,
    public toastrService: ToastrService,
  ) { }

  private _nqaFlag: number = null;
  get NQAFlag(): number {
    return this._nqaFlag;
  }
  set NQAFlag(value: number) {
    this._nqaFlag = value;
  }

  refreshTable() {
    this.activitiesProjectTableRefresh.next(true);
  }

  showAssignNavLink() {
    this.assignActivitiesProjects.next(true);
  }

  showAssignNavLinkComplete() {
    this.assignActivitiesProjects.next(false);
  }

  GetSurveyPrepList(groupId: number, employeeIds: number[]): Observable<any> {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (this.engagementId !== undefined || this.engagementId !== null || this.engagementId !== '') {
      let payload: TimeSurveyGroupRequestDto = {
        groupId: groupId.toString(),
        engagementId: Number(this.engagementId),
        nqaFlag: this.NQAFlag,
        employeeIds: employeeIds
      }
      return this.sessionService.apiUrlPost(API_URL.GENERETESURVEY.GETSURVEYPREPLIST, payload)
        .pipe(map((data: BaseResponse) => data.result));
    }
  }

  GetSurveyPrepListByGroupIds(groupIds: number[], selectedEmployeeIds: number[]): Observable<any> {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (this.engagementId !== undefined || this.engagementId !== null || this.engagementId !== '') {
      let payload: TimeSurveyGroupRequestDto = {
        groupId: groupIds.toString(),
        engagementId: Number(this.engagementId),
        nqaFlag: this.NQAFlag,
        employeeIds: selectedEmployeeIds
      }
      return this.sessionService.apiUrlPost(API_URL.GENERETESURVEY.GETSURVEYPREPLIST, payload)
        .pipe(map((data: BaseResponse) => data.result));
    }
  }

  GetActivityList(groupId: number, groupValue: string): Observable<any> {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (
      this.engagementId !== undefined ||
      this.engagementId !== null ||
      this.engagementId !== ''
    ) {
      return this.sessionService.apiUrlGet(
        API_URL.GENERETESURVEY.GETACTIVITYLIST +
        '?engagementId=' +
        this.engagementId,
      );
    }
  }

  GetProjectsList(groupId: number, groupValue: string): Observable<any> {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (
      this.engagementId !== undefined ||
      this.engagementId !== null ||
      this.engagementId !== ''
    ) {
      return this.sessionService.apiUrlGet(
        API_URL.GENERETESURVEY.GETPROJECTLIST +
        '?engagementId=' +
        this.engagementId,
      );
    }
  }

  setSharedData(valueChange: any) {
    this.activityProjectData.next(valueChange);
  }

  getSharedData() {
    return this.activityProjectData.asObservable();
  }

  GenerateSurvey(generateSurvey: GenerateSurvey) {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (
      this.engagementId !== undefined ||
      this.engagementId !== null ||
      this.engagementId !== ''
    ) {
      generateSurvey.engagementId = +this.engagementId;
      return this.sessionService.apiUrlPost(
        API_URL.GENERETESURVEY.GENERATE_SURVEY,
        generateSurvey,
      );
    }
  }

  private autoGenerateSurvey: any;
  private autoSurveyPrepData: SurveyPrepDataEntity[] = [];
  private autoGroupId: number;
  private autoSurveyTypeId: number;
  generateExtraSurvey(surveyPrepData: SurveyPrepDataEntity[], groupId: number, surveyTypeId: number) {

    /*  this.autoSurveyPrepData = surveyPrepData;
     this.autoGroupId = groupId;
     this.autoSurveyTypeId = surveyTypeId;
     this.autoGenerateSurvey = setTimeout(() => this.autoGenerateExtraSurvey(), 500);
      */
    while (surveyPrepData.length) {
      let inputData: GenerateSurvey = {
        engagementId: 0,
        groupId: groupId,
        surveyTypeId: surveyTypeId,
        groups: null,
        surveyCreationData: surveyPrepData.splice(0, 100)
      }

      this.GenerateSurvey(inputData)
        .subscribe(
          (data: BaseResponse) => {
            if (data != null && !data.success) {
              console.log("Survey Creation failed Msg: " + data.errorMessage);
              console.log("Survey Creation failed Msg data: " + inputData);
            }
          },
          error => {
            console.log("Survey Creation failed Msg error data: " + inputData);
          },
        );
    };
  }

  autoGenerateExtraSurvey() {
    if (this.autoSurveyPrepData.length > 0) {
      clearTimeout(this.autoGenerateSurvey);
      let inputData: GenerateSurvey = {
        engagementId: 0,
        groupId: this.autoGroupId,
        surveyTypeId: this.autoSurveyTypeId,
        groups: null,
        surveyCreationData: this.autoSurveyPrepData.splice(0, 100)
      }

      this.GenerateSurvey(inputData)
        .subscribe(
          (data: BaseResponse) => {
            if (data != null && !data.success) {
              console.log("Survey Creation failed Msg: " + data.errorMessage);
              console.log("Survey Creation failed Msg data: " + inputData);
            }
          },
          error => {
            console.log("Survey Creation failed Msg error data: " + inputData);
          },
        );
      this.autoGenerateSurvey = setTimeout(() => this.autoGenerateExtraSurvey(), 500);
    } else {
      clearTimeout(this.autoGenerateSurvey);
      this.autoSurveyPrepData = [];
      this.autoGroupId = 0;
      this.autoSurveyTypeId = 0;
    }
  }

  GetEmployees(groupId: number, groupValue: string) {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (
      this.engagementId !== undefined ||
      this.engagementId !== null ||
      this.engagementId !== ''
    ) {
      return this.sessionService.apiUrlGet(
        API_URL.GENERETESURVEY.GET_EMPLOYESS_BY_GROUP +
        '?engagementId=' +
        this.engagementId +
        '&groupId=' +
        groupId +
        '&groupVal=' +
        groupValue,
      );
    }
  }

  GetEmployeesByPost(mployeesInSurvey: EmployeesInSurvey) {
    this.engagementId = this.sessionService.getSession('engagementId');
    if (
      this.engagementId !== undefined ||
      this.engagementId !== null ||
      this.engagementId !== ''
    ) {
      return this.sessionService.apiUrlPost(
        API_URL.GENERETESURVEY.GET_EMPLOYESS_BY_GROUP,
        mployeesInSurvey,
      );
    }
  }
  removeUnusedAttributes(surveyData: SurveyPrepDataEntity[]) {
    let surveyDataCopied: SurveyPrepDataEntity[] = copyObject(surveyData);

    surveyDataCopied.forEach(surveyPrepEntity => {

      //surveyPrepEntity.groupValue = window.btoa(unescape(encodeURIComponent(surveyPrepEntity.groupValue)));
      if (surveyPrepEntity.projects?.length > 0) {
        surveyPrepEntity.projects = surveyPrepEntity.projects.map(
          proj => ({ projectId: proj.projectId } as EngagementGroupProject))
      }
      if (surveyPrepEntity.activities?.length > 0) {
        surveyPrepEntity.activities = surveyPrepEntity.activities.map(
          act => ({ activityId: act.activityId } as EngagementGroupActivity))
      }
      if (surveyPrepEntity.nqas?.length > 0) {
        surveyPrepEntity.nqas = surveyPrepEntity.nqas.map(
          nqa => ({ activityId: nqa.activityId } as EngagementGroupActivity))
      }
      if (surveyPrepEntity.nwts?.length > 0) {
        surveyPrepEntity.nwts = surveyPrepEntity.nwts.map(
          nwt => ({ activityId: nwt.activityId } as EngagementGroupActivity))
      }

    });

    return surveyDataCopied;
  }

}

